import { MAP_GROUP_COLOR_PALETTE } from '@/constants/colors';

import { EVENT_STATE_MAIN_COLORS, NeedsAttentionState } from '../../../liveView/LiveView';

// Gray for stops with no group.
const NEUTRAL_COLOR = '#666';

// Beyond the curated palette, generate distinct hues so colors never repeat.
// Stepping by the golden angle keeps successive hues far apart without needing
// the total; this only kicks in past 20 groups on one map (rare).
const GOLDEN_ANGLE_DEG = 137.508;
const GENERATED_SATURATION_PCT = 70;
const GENERATED_LIGHTNESS_PCT = 45;

// Color is a pure function of the group index, so the legend swatch and the map
// pin (keyed by the same index) always match.
export const getGroupColor = (index: number | null): string => {
    if (index === null) {
        return NEUTRAL_COLOR;
    }
    if (index < MAP_GROUP_COLOR_PALETTE.length) {
        return MAP_GROUP_COLOR_PALETTE[index];
    }
    const generatedIndex = index - MAP_GROUP_COLOR_PALETTE.length;
    const hue = Math.round(generatedIndex * GOLDEN_ANGLE_DEG) % 360;
    return `hsl(${hue}, ${GENERATED_SATURATION_PCT}%, ${GENERATED_LIGHTNESS_PCT}%)`;
};

export const getColorFromLegendState = (legendState: NeedsAttentionState | null | undefined) => {
    if (!legendState) {
        return NEUTRAL_COLOR;
    }
    return EVENT_STATE_MAIN_COLORS[legendState];
};
